export default "__VITE_ASSET__BHLt4OfM__"